"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_MEMBER_INFO_IN_SPACE = exports.UPDATE_MEMBER_LIST_IN_SPACE = exports.UPDATE_RIGHT_CLICK_TEAM_INFO_IN_SPACE = exports.UPDATE_SELECTED_TEAM_INFO_IN_SPACE = exports.UPDATE_INVITED_STATUS = exports.UPDATE_TEAM_LIST_IN_SPACE = exports.UPDATE_MEMBER_INFO = exports.UPDATE_MEMBER_LIST = exports.UPDATE_SELECTED_TEAM_INFO = exports.UPDATE_TEAM_LIST = exports.SET_ROOT_ID = exports.SET_FILL_HANDLE_STATUS = exports.SET_FIELD_RANGES = exports.CLEAR_SELECTION_BUT_KEEP_CHECKED_RECORD = exports.CLEAR_SELECTION = exports.SET_RECORD_SELECTION = exports.SET_ACTIVE_CELL = exports.SET_SELECTION = exports.GET_SELECTION = exports.SET_LOADING_RECORD = exports.ADD_DATASHEET = exports.RESET_DATASHEET = exports.MIRROR_DEACTIVATE_COLLABORATOR = exports.DASHBOARD_DEACTIVATE_COLLABORATOR = exports.DATASHEET_DEACTIVATE_COLLABORATOR = exports.CURSOR_MOVE = exports.SET_HIGHLIGHT_FIELD_ID = exports.MIRROR_ACTIVE_COLLABORATOR = exports.DASHBOARD_ACTIVE_COLLABORATOR = exports.DATASHEET_ACTIVE_COLLABORATOR = exports.SEND_USERCHANGE_REJECT = exports.SEND_USERCHANGE_ACK = exports.SEND_USERCHANGE = exports.DATAPACK_REQUEST = exports.RESET_EXPORT_VIEW_ID = exports.ACTIVE_EXPORT_VIEW_ID = exports.RESET_OPERATE_VIEW_ID = exports.ACTIVE_OPERATE_VIEW_ID = exports.CACHE_TEMPORARY_QUERY_VIEW = exports.CACHE_TEMPORARY_VIEW = exports.DATAPACK_LOADED = exports.SWITCH_VIEW = exports.TOGGLE_EDITING = exports.SWITCH_CARD_EDITOR = exports.APPLY_OPERATION = exports.REFRESH_SNAPSHOT = exports.SET_ACTIVE_ROW_INFO = exports.CLEAR_ACTIVE_ROW_INFO = exports.SET_NEW_RECORD_EXPECT_INDEX = exports.SET_ROBOT_PANEL_STATUS = void 0;
exports.SET_ERR = exports.SET_OPT_NODE = exports.CO_LAYER_MOVE_NODE = exports.MOVE_NODE_TO_FOLDER = exports.DELETE_NODE = exports.SET_DEL_NODE_ID = exports.CHANGE_VIEW = exports.SET_NODE_ERROR_TYPE = exports.SET_NODE_NAME = exports.SCROLL_OFFSET = exports.GET_NEW_MSG_FROM_WS_AND_LOOK = exports.UPDATE_NEW_NOTICE_LIST_FROM_WS = exports.DEL_UNREAD_NOTICE_LIST = exports.UPDATE_UNREAD_NOTICE_LIST = exports.UPDATE_READ_NOTICE_LIST = exports.UPDATE_READ_MSG_COUNT = exports.UPDATE_UNREAD_MSG_COUNT = exports.UPDATE_INVITE_ERR = exports.UPDATE_INVITE_EMAIL_INFO = exports.SET_NO_PERMISSION_MEMBERS = exports.SET_PERMISSION_COMMIT_REMIND_PARAMETER = exports.SET_PERMISSION_COMMIT_REMIND_STATUS = exports.UPDATE_SPACE_RESOURCE = exports.UPDATE_INVITE_ERR_CODE = exports.UPDATE_MAIL_TOKEN = exports.UPDATE_LINK_TOKEN = exports.UPDATE_INVITE_LINK_INFO = exports.UPDATE_SUB_TEAM_TREE_INVITE = exports.UPDATE_TEAM_TREE_INVITE = exports.UPDATE_SUBSCRIPTION = exports.SET_GRID_VIEW_HOVER_FIELD_ID = exports.ADD_WIZARD_NUMBER = exports.UPDATE_USERINFO_ERR = exports.UPDATE_SINGLE_MEMBER_IN_MEMBERLIST = exports.UPDATE_DATASHEET_NAME = exports.SET_CONNECTED = exports.SET_RECONNECTING = exports.UPDATE_MAIN_ADMIN_INFO = exports.UPDATE_MEMBER_LIST_PAGE = exports.UPDATE_MEMBER_LIST_LOADING = exports.UPDATE_MEMBER_LIST_TOTAL = exports.UPDATE_MEMBER_LIST_PAGE_NO = exports.UPDATE_ADDRESS_TREE = exports.UPDATE_PERMISSION_LIST = exports.UPDATE_SUB_ADMIN_LIST_DATA = exports.UPDATE_SELECTED_TEAM_ROWS = exports.UPDATE_SELECTED_TEAM_KEYS = exports.UPDATE_SUB_TEAM_LIST_IN_SPACE = exports.UPDATE_SELECT_MEMBER_LIST_IN_SPACE = exports.UPDATE_SELECTED_ROWS_IN_SPACE = void 0;
exports.SET_EXPANDED_KEYS = exports.INIT_TAB_BAR = exports.INIT_TAB_BAR_INFO = exports.SET_DRAG_NODE_ID = exports.SET_EDIT_INDEX = exports.SET_TAB_ITEM_TO_INDEX = exports.COPY_TAB_ITEM = exports.RENAME_TAB_ITEM = exports.MOVE_TAB_ITEM = exports.REMOVE_TAB_ITEM = exports.ADD_TAB_ITEM = exports.UPDATE_MOVE_TO_NODE_IDS = exports.SET_LOADED_KEYS = exports.UPDATE_IMPORT_MODAL_NODE_ID = exports.UPDATE_SAVE_AS_TEMPLATE_MODAL_NODE_ID = exports.UPDATE_SHARE_MODAL_NODE_ID = exports.UPDATE_PERMISSION_MODAL_NODE_ID = exports.INIT_FAVORITE_TREE_NODES = exports.MOVE_FAVORITE_NODE = exports.DELETE_NODE_FROM_FAVORITE_LIST = exports.SET_FAVORITE_LOADING = exports.SET_FAVORITE_DEL_NODE_ID = exports.SET_FAVORITE_EDIT_NODE_ID = exports.SET_FAVORITE_EXPANDED_KEYS = exports.REMOVE_FAVORITE_NODE = exports.ADD_NODE_TO_FAVORITE_LIST = exports.SET_TREE_ROOT_ID = exports.SET_ACTIVE_NODE_ERROR = exports.REFRESH_TREE = exports.UPDATE_SOCKET_DATA = exports.UPDATE_IS_PERMISSION = exports.REMOVE_NODE_FROM_TREE = exports.REMOVE_NODE_FROM_MAP = exports.UPDATE_USERINFO = exports.SET_NICKNAME = exports.CLEAR_NODE = exports.UPDATE_TREE_NODES_MAP = exports.NODE_MOVE_TO = exports.UPDATE_HAS_CHILDREN = exports.TREE_LOADING = exports.SET_ALL_VISIBLE = exports.SET_COPY_NODE_ID = exports.UPDATE_LINK_LIST = exports.INIT_CATALOG_TREE = exports.SET_IS_COPY_ALL = exports.SET_ACTIVE_DST_ID = exports.CLEAR_TASK_QUEUE = exports.ADD_NODE_TO_MAP = exports.ADD_TASK = exports.SET_EDIT_NODE_ID = void 0;
exports.SET_CALENDAR_SETTING_PANEL_WIDTH = exports.TOGGLE_CALENDAR_SETTING_PANEL = exports.SET_CALENDAR_GRID_WIDTH = exports.TOGGLE_CALENDAR_GRID = exports.TOGGLE_CALENDAR_GUIDE_STATUS = exports.SET_GANTT_DATE_UNIT_TYPE = exports.SET_GANTT_SETTING_PANEL_WIDTH = exports.TOGGLE_GANTT_SETTING_PANEL = exports.SET_GANTT_GRID_WIDTH = exports.TOGGLE_GANTT_GRID = exports.TOGGLE_KANBAN_GROUP_SETTING_VISIBLE = exports.SET_KANBAN_GROUPING_EXPAND = exports.SET_GROUPING_COLLAPSE = exports.SET_CHANGE_COLUMNS_WIDTH = exports.SET_ENVS = exports.SET_ACTIVE_SPACE_ID = exports.SET_MARKETPLACE_APPS = exports.SET_SHORTCUT_KEY_PANEL_VISIBLE = exports.SET_SPACE_FEATURES = exports.SET_SPACE_INFO = exports.SET_SPACE_LOADING = exports.SET_SPACE_ERR = exports.SET_QUIT_SPACE_ID = exports.SET_SPACE_LIST = exports.SET_TEMP_SELECTION = exports.SET_ACTIVE_FIELD_STATE = exports.SET_PAGE_PARAMS = exports.UPDATE_SOCIAL_CONFIG = exports.SET_HOVER_RECORD_ID = exports.SET_DRAG_MOVE = exports.SET_DRAG_TARGET = exports.SET_PWD = exports.SET_ACTIVE_RECORD_ID = exports.SET_HTTP_ERR_INFO = exports.SET_REQ_STATUS = exports.SET_USER_TIMEZONE = exports.SET_USER_AVATAR_COLOR = exports.SET_USER_AVATAR = exports.SIGN_OUT = exports.SET_LOADING = exports.SET_IS_CREATE_SPACE = exports.SET_IS_CODE = exports.SET_USED_INVITE_REWARD = exports.SET_REGISTER_STATUS = exports.SET_HOME_ERR = exports.SET_IS_LOGIN = exports.SET_USER_ME = exports.TOGGLE_RECORD_PANEL_FULL_SCREEN = exports.TOGGLE_SIDE_RECORD_PANEL = exports.TOGGLE_API_PANEL = void 0;
exports.UPDATE_FORM_UNIT_MAP = exports.CHANGE_RESOURCE_SYNCING_STATUS = exports.RESOURCE_CONNECTED = exports.SET_THEME = exports.SET_RECORD_VISION_MODE = exports.RESET_FORM = exports.FORM_ACTIVE_COLLABORATOR = exports.FORM_DEACTIVATE_COLLABORATOR = exports.UPDATE_FORM_NAME = exports.SET_FORM_SYNCING = exports.SET_FORM_DATA = exports.SET_FORM_LOADING = exports.SET_FORM_CLIENT = exports.FORM_ROOM_INFO_SYNC = exports.UPDATE_FORM = exports.FORM_PROP_UPDATE = exports.FORM_CONNECTED = exports.FORM_LOADED = exports.FORM_REQUEST = exports.FORM_JOT_ACTION = exports.TOGGLE_TIME_MACHINE_PANEL = exports.SET_HOVER_ROW_OF_ADD_RECORD = exports.SET_HOVER_GROUP_PATH = exports.SET_SEARCH_RESULT_CURSOR_INDEX = exports.RESET_UNIT_INFO = exports.SET_SEARCH_KEYWORD = exports.UPDATE_USER_MAP = exports.UPDATE_UNIT_MAP = exports.SET_RIGHT_PANE_WIDTH = exports.SET_TOOLBAR_MENU_CARD_OPEN = exports.CLEAR_WIZARDS_DATA = exports.UPDATE_CURRENT_GUIDE_WIZARD_ID = exports.INIT_HOOKS_DATA = exports.UPDATE_TRIGGERED_GUIDE_INFO = exports.UPDATE_CONFIG = exports.UPDATE_CURRENT_GUIDE_STEP_IDS = exports.UPDATE_PENDING_GUIDE_WIZARD_IDS = exports.CLEAR_FIELD_INFO = exports.SET_NODE_ICON = exports.SET_SIDEBAR_VISIBLE = exports.SET_SCREEN_WIDTH = exports.RECORD_NODE_SHARED = exports.SET_SHARE_MEMBER_ID = exports.RECORD_NODE_DESC = exports.SET_EDIT_STATUS = exports.SET_ORG_CHART_SETTING_PANEL_WIDTH = exports.TOGGLE_ORG_CHART_SETTING_PANEL = exports.SET_ORG_CHART_GRID_WIDTH = exports.TOGGLE_ORG_CHART_GRID = exports.TOGGLE_ORG_CHART_GUIDE_STATUS = void 0;
exports.SET_SHARE_INFO = exports.UPDATE_TEMPLATE_DIRECTORY = exports.UPDATE_TEMPLATE_CATEGORY = exports.EXPAND_STATUS = exports.MIRROR_SAVE_STATUS = exports.UPDATE_SNAPSHOT = exports.UPDATE_MIRROR = exports.UPDATE_DASHBOARD = exports.UPDATE_DATASHEET = exports.MIRROR_ERROR_CODE = exports.DASHBOARD_ERROR_CODE = exports.DATASHEET_ERROR_CODE = exports.FORM_ERROR_CODE = exports.MIRROR_ROOM_INFO_SYNC = exports.DASHBOARD_ROOM_INFO_SYNC = exports.DATASHEET_ROOM_INFO_SYNC = exports.SET_MIRROR_SYNCING = exports.SET_DASHBOARD_SYNCING = exports.SET_DATASHEET_SYNCING = exports.MIRROR_CONNECTED = exports.DASHBOARD_CONNECTED = exports.DATASHEET_CONNECTED = exports.FORM_UPDATE_REVISION = exports.WIDGET_UPDATE_REVISION = exports.DASHBOARD_UPDATE_REVISION = exports.DATASHEET_UPDATE_REVISION = exports.MIRROR_UPDATE_REVISION = exports.WIDGET_JOT_ACTION = exports.DASHBOARD_JOT_ACTION = exports.DATASHEET_JOT_ACTION = exports.MIRROR_JOT_ACTION = exports.UPDATE_MIRROR_INFO = exports.UPDATE_MIRROR_NAME = exports.RESET_MIRROR = exports.SET_MIRROR_CLIENT = exports.SET_MIRROR_DATA = exports.SET_MIRROR_LOADING = exports.UPDATE_DASHBOARD_INFO = exports.UPDATE_DASHBOARD_NAME = exports.RESET_DASHBOARD = exports.SET_DASHBOARD_CLIENT = exports.SET_DASHBOARD_DATA = exports.SET_DASHBOARD_LOADING = exports.RESET_WIDGET = exports.RECEIVE_INSTALLATIONS_WIDGET = exports.SET_WIDGET_PANEL_LOADING = exports.SWITCH_ACTIVE_PANEL = exports.CHANGE_WIDGET_PANEL_WIDTH = exports.TOGGLE_WIDGET_PANEL = exports.SET_RIGHT_CLICK_INFO = void 0;
exports.TRIGGER_VIEW_DERIVATION_COMPUTED = exports.PATCH_VIEW_DERIVATION = exports.DELETE_VIEW_DERIVATION = exports.SET_VIEW_DERIVATION = exports.SET_PREVIEW_DEFAULT_ACTIVE = exports.SET_PREVIEW_FILE_CELL_ACTIVE = exports.SET_PREVIEW_FILE = exports.SET_SUBSCRIPTIONS = exports.SET_LABS = exports.SET_CLOSE_SYNC_VIEW_ID = exports.SET_DATASHEET_COMPUTED_STATUS = exports.UPDATE_DATASHEET_COMPUTED_COLUMNS = exports.UPDATE_DATASHEET_COMPUTED_ROWS = exports.SET_DATASHEET_COMPUTED = exports.UPDATE_DATASHEET_COMPUTED = exports.UPDATE_FIELD_PERMISSION_SETTING = exports.LOAD_FIELD_PERMISSION_MAP = exports.RESET_FIELD_PERMISSION_MAP = exports.UPDATE_FIELD_PERMISSION_MAP = exports.SET_PREVIEW_MODAL_VISIBLE = void 0;
exports.SET_ROBOT_PANEL_STATUS = 'SET_ROBOT_PANEL_STATUS';
exports.SET_NEW_RECORD_EXPECT_INDEX = 'SET_NEW_RECORD_EXPECT_INDEX';
exports.CLEAR_ACTIVE_ROW_INFO = 'CLEAR_ACTIVE_ROW_INFO';
exports.SET_ACTIVE_ROW_INFO = 'SET_ACTIVE_ROW_INFO';
exports.REFRESH_SNAPSHOT = 'REFRESH_SNAPSHOT';
exports.APPLY_OPERATION = 'APPLY_OPERATION';
exports.SWITCH_CARD_EDITOR = 'SWITCH_CARD_EDITOR';
exports.TOGGLE_EDITING = 'TOGGLE_EDITING';
exports.SWITCH_VIEW = 'SWITCH_VIEW';
exports.DATAPACK_LOADED = 'DATAPACK_LOADED';
exports.CACHE_TEMPORARY_VIEW = 'CACHE_TEMPORARY_VIEW';
exports.CACHE_TEMPORARY_QUERY_VIEW = 'CACHE_TEMPORARY_QUERY_VIEW';
exports.ACTIVE_OPERATE_VIEW_ID = 'ACTIVE_OPERATE_VIEW_ID';
exports.RESET_OPERATE_VIEW_ID = 'RESET_OPERATE_VIEW_ID';
exports.ACTIVE_EXPORT_VIEW_ID = 'ACTIVE_EXPORT_VIEW_ID';
exports.RESET_EXPORT_VIEW_ID = 'RESET_EXPORT_VIEW_ID';
exports.DATAPACK_REQUEST = 'DATAPACK_REQUEST';
exports.SEND_USERCHANGE = 'SEND_USERCHANGE';
exports.SEND_USERCHANGE_ACK = 'SEND_USERCHANGE_ACK';
exports.SEND_USERCHANGE_REJECT = 'SEND_USERCHANGE_REJECT';
exports.DATASHEET_ACTIVE_COLLABORATOR = 'DATASHEET_ACTIVE_COLLABORATOR';
exports.DASHBOARD_ACTIVE_COLLABORATOR = 'DASHBOARD_ACTIVE_COLLABORATOR';
exports.MIRROR_ACTIVE_COLLABORATOR = 'MIRROR_ACTIVE_COLLABORATOR';
exports.SET_HIGHLIGHT_FIELD_ID = 'SET_HIGHLIGHT_FIELD_ID';
exports.CURSOR_MOVE = 'CURSOR_MOVE';
exports.DATASHEET_DEACTIVATE_COLLABORATOR = 'DATASHEET_DEACTIVATE_COLLABORATOR';
exports.DASHBOARD_DEACTIVATE_COLLABORATOR = 'DASHBOARD_DEACTIVATE_COLLABORATOR';
exports.MIRROR_DEACTIVATE_COLLABORATOR = 'MIRROR_DEACTIVATE_COLLABORATOR';
exports.RESET_DATASHEET = 'RESET_DATASHEET';
exports.ADD_DATASHEET = 'ADD_DATASHEET';
exports.SET_LOADING_RECORD = 'SET_LOADING_RECORD';
exports.GET_SELECTION = 'GET_SELECTION';
exports.SET_SELECTION = 'SET_SELECTION';
exports.SET_ACTIVE_CELL = 'SET_ACTIVE_CELL';
exports.SET_RECORD_SELECTION = 'SET_RECORD_SELECTION';
exports.CLEAR_SELECTION = 'CLEAR_SELECTION';
exports.CLEAR_SELECTION_BUT_KEEP_CHECKED_RECORD = 'CLEAR_SELECTION_BUT_KEEP_CHECKED_RECORD';
exports.SET_FIELD_RANGES = 'SET_FIELD_RANGES';
exports.SET_FILL_HANDLE_STATUS = 'SET_FILL_HANDLE_STATUS';
exports.SET_ROOT_ID = 'SET_ROOT_ID';
exports.UPDATE_TEAM_LIST = 'UPDATE_TEAM_LIST';
exports.UPDATE_SELECTED_TEAM_INFO = 'UPDATE_SELECTED_TEAM_INFO';
exports.UPDATE_MEMBER_LIST = 'UPDATE_MEMBER_LIST';
exports.UPDATE_MEMBER_INFO = 'UPDATE_MEMBER_INFO';
exports.UPDATE_TEAM_LIST_IN_SPACE = 'UPDATE_TEAM_LIST_IN_SPACE';
exports.UPDATE_INVITED_STATUS = 'UPDATE_INVITED_STATUS';
exports.UPDATE_SELECTED_TEAM_INFO_IN_SPACE = 'UPDATE_SELECTED_TEAM_INFO_IN_SPACE';
exports.UPDATE_RIGHT_CLICK_TEAM_INFO_IN_SPACE = 'UPDATE_RIGHT_CLICK_TEAM_INFO_IN_SPACE';
exports.UPDATE_MEMBER_LIST_IN_SPACE = 'UPDATE_MEMBER_LIST_IN_SPACE';
exports.UPDATE_MEMBER_INFO_IN_SPACE = 'UPDATE_MEMBER_INFO_IN_SPACE';
exports.UPDATE_SELECTED_ROWS_IN_SPACE = 'UPDATE_SELECTED_ROWS_IN_SPACE';
exports.UPDATE_SELECT_MEMBER_LIST_IN_SPACE = 'UPDATE_SELECT_MEMBER_LIST_IN_SPACE';
exports.UPDATE_SUB_TEAM_LIST_IN_SPACE = 'UPDATE_SUB_TEAM_LIST_IN_SPACE';
exports.UPDATE_SELECTED_TEAM_KEYS = 'UPDATE_SELECTED_TEAM_KEYS';
exports.UPDATE_SELECTED_TEAM_ROWS = 'UPDATE_SELECTED_TEAM_ROWS';
exports.UPDATE_SUB_ADMIN_LIST_DATA = 'UPDATE_SUB_ADMIN_LIST_DATA';
exports.UPDATE_PERMISSION_LIST = 'UPDATE_PERMISSION_LIST';
exports.UPDATE_ADDRESS_TREE = 'UPDATE_ADDRESS_TREE';
exports.UPDATE_MEMBER_LIST_PAGE_NO = 'UPDATE_MEMBER_LIST_PAGE_NO';
exports.UPDATE_MEMBER_LIST_TOTAL = 'UPDATE_MEMBER_LIST_TOTAL';
exports.UPDATE_MEMBER_LIST_LOADING = 'UPDATE_MEMBER_LIST_LOADING';
exports.UPDATE_MEMBER_LIST_PAGE = 'UPDATE_MEMBER_LIST_PAGE';
/**
 * update main admin info
 */
exports.UPDATE_MAIN_ADMIN_INFO = 'UPDATE_MAIN_ADMIN_INFO';
exports.SET_RECONNECTING = 'SET_RECONNECTING';
exports.SET_CONNECTED = 'SET_CONNECTED';
exports.UPDATE_DATASHEET_NAME = 'UPDATE_DATASHEET_NAME';
exports.UPDATE_SINGLE_MEMBER_IN_MEMBERLIST = 'UPDATE_SINGLE_MEMBER_IN_MEMBERLIST';
exports.UPDATE_USERINFO_ERR = 'UPDATE_USERINFO_ERR';
exports.ADD_WIZARD_NUMBER = 'ADD_WIZARD_NUMBER';
exports.SET_GRID_VIEW_HOVER_FIELD_ID = 'SET_GRID_VIEW_HOVER_FIELD_ID';
// billing
exports.UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
// invite
exports.UPDATE_TEAM_TREE_INVITE = 'UPDATE_TEAM_TREE_INVITE';
exports.UPDATE_SUB_TEAM_TREE_INVITE = 'UPDATE_SUB_TEAM_TREE_INVITE';
exports.UPDATE_INVITE_LINK_INFO = 'UPDATE_INVITE_LINK_INFO';
exports.UPDATE_LINK_TOKEN = 'UPDATE_LINK_TOKEN';
exports.UPDATE_MAIL_TOKEN = 'UPDATE_MAIL_TOKEN';
exports.UPDATE_INVITE_ERR_CODE = 'UPDATE_INVITE_ERR_CODE';
/**
 * permission related
 */
exports.UPDATE_SPACE_RESOURCE = 'UPDATE_SPACE_RESOURCE';
exports.SET_PERMISSION_COMMIT_REMIND_STATUS = 'SET_PERMISSION_COMMIT_REMIND_STATUS';
exports.SET_PERMISSION_COMMIT_REMIND_PARAMETER = 'SET_PERMISSION__COMMIT_REMIND_PARAMETER';
exports.SET_NO_PERMISSION_MEMBERS = 'SET_NO_PERMISSION_MEMBERS';
/**
 * invite email
 */
exports.UPDATE_INVITE_EMAIL_INFO = 'UPDATE_INVITE_EMAIL_INFO';
exports.UPDATE_INVITE_ERR = 'UPDATE_INVITE_ERR';
/**
 * notification center
 */
exports.UPDATE_UNREAD_MSG_COUNT = 'UPDATE_UNREAD_MSG_COUNT';
exports.UPDATE_READ_MSG_COUNT = 'UPDATE_READ_MSG_COUNT';
exports.UPDATE_READ_NOTICE_LIST = 'ADD_READ_NOTICE_LIST';
exports.UPDATE_UNREAD_NOTICE_LIST = 'ADD_UNREAD_NOTICE_LIST';
exports.DEL_UNREAD_NOTICE_LIST = 'DEL_UNREAD_NOTICE_LIST';
exports.UPDATE_NEW_NOTICE_LIST_FROM_WS = 'UPDATE_NEW_NOTICE_LIST_FROM_WS';
exports.GET_NEW_MSG_FROM_WS_AND_LOOK = 'GET_NEW_MSG_FROM_WS_AND_LOOK';
/**
 * mouse scrolling position
 */
exports.SCROLL_OFFSET = 'SCROLL_OFFSET';
exports.SET_NODE_NAME = 'SET_NODE_NAME';
/**
 * if the sub-node request failed
 */
exports.SET_NODE_ERROR_TYPE = 'SET_NODE_ERROR_TYPE';
/**
 * update the view
 */
exports.CHANGE_VIEW = 'CHANGE_VIEW';
exports.SET_DEL_NODE_ID = 'SET_DEL_NODE_ID';
exports.DELETE_NODE = 'DELETE_NODE';
exports.MOVE_NODE_TO_FOLDER = 'MOVE_NODE_TO_FOLDER';
exports.CO_LAYER_MOVE_NODE = 'CO_LAYER_MOVE_NODE';
exports.SET_OPT_NODE = 'SET_OPT_NODE';
exports.SET_ERR = 'SET_ERR';
exports.SET_EDIT_NODE_ID = 'SET_EDIT_NODE_ID';
exports.ADD_TASK = 'ADD_TASK';
exports.ADD_NODE_TO_MAP = 'ADD_NODE_TO_MAP';
exports.CLEAR_TASK_QUEUE = 'CLEAR_TASK_QUEUE';
exports.SET_ACTIVE_DST_ID = 'SET_ACTIVE_DST_ID';
exports.SET_IS_COPY_ALL = 'SET_IS_COPY_ALL';
exports.INIT_CATALOG_TREE = 'INIT_CATALOG_TREE';
exports.UPDATE_LINK_LIST = 'UPDATE_LINK_LIST';
// catalog
exports.SET_COPY_NODE_ID = 'SET_COPY_NODE_ID';
exports.SET_ALL_VISIBLE = 'SET_ALL_VISIBLE';
exports.TREE_LOADING = 'TREE_LOADING';
exports.UPDATE_HAS_CHILDREN = 'UPDATE_HAS_CHILDREN';
exports.NODE_MOVE_TO = 'NODE_MOVE_TO';
exports.UPDATE_TREE_NODES_MAP = 'UPDATE_TREE_NODES_MAP';
exports.CLEAR_NODE = 'CLEAR_NODE';
exports.SET_NICKNAME = 'SET_NICKNAME';
exports.UPDATE_USERINFO = 'UPDATE_USERINFO';
exports.REMOVE_NODE_FROM_MAP = 'REMOVE_NODE_FROM_MAP';
exports.REMOVE_NODE_FROM_TREE = 'REMOVE_NODE_FROM_TREE';
exports.UPDATE_IS_PERMISSION = 'UPDATE_IS_PERMISSION';
exports.UPDATE_SOCKET_DATA = 'UPDATE_SOCKET_DATA';
exports.REFRESH_TREE = 'REFRESH_TREE';
exports.SET_ACTIVE_NODE_ERROR = 'SET_ACTIVE_NODE_ERROR';
exports.SET_TREE_ROOT_ID = 'SET_TREE_ROOT_ID';
exports.ADD_NODE_TO_FAVORITE_LIST = 'ADD_NODE_TO_FAVORITE_LIST';
exports.REMOVE_FAVORITE_NODE = 'REMOVE_FAVORITE_NODE';
exports.SET_FAVORITE_EXPANDED_KEYS = 'SET_FAVORITE_EXPANDED_KEYS';
exports.SET_FAVORITE_EDIT_NODE_ID = 'SET_FAVORITE_EDIT_NODE_ID';
exports.SET_FAVORITE_DEL_NODE_ID = 'SET_FAVORITE_DEL_NODE_ID';
exports.SET_FAVORITE_LOADING = 'SET_FAVORITE_LOADING';
exports.DELETE_NODE_FROM_FAVORITE_LIST = 'DELETE_NODE_FROM_FAVORITE_LIST';
exports.MOVE_FAVORITE_NODE = 'MOVE_FAVORITE_NODE';
exports.INIT_FAVORITE_TREE_NODES = 'INIT_FAVORITE_TREE_NODES';
exports.UPDATE_PERMISSION_MODAL_NODE_ID = 'UPDATE_PERMISSION_MODAL_NODE_ID';
exports.UPDATE_SHARE_MODAL_NODE_ID = 'UPDATE_SHARE_MODAL_NODE_ID';
exports.UPDATE_SAVE_AS_TEMPLATE_MODAL_NODE_ID = 'UPDATE_SAVE_AS_TEMPLATE_MODAL_NODE_ID';
exports.UPDATE_IMPORT_MODAL_NODE_ID = 'UPDATE_IMPORT_MODAL_NODE_ID';
exports.SET_LOADED_KEYS = 'SET_LOADED_KEYS';
exports.UPDATE_MOVE_TO_NODE_IDS = 'UPDATE_MOVE_TO_NODE_IDS';
// tabBar
exports.ADD_TAB_ITEM = 'ADD_TAB_ITEM';
exports.REMOVE_TAB_ITEM = 'REMOVE_TAB_ITEM';
exports.MOVE_TAB_ITEM = 'MOVE_TAB_ITEM';
exports.RENAME_TAB_ITEM = 'RENAME_TAB_ITEM';
exports.COPY_TAB_ITEM = 'COPY_TAB_ITEM';
exports.SET_TAB_ITEM_TO_INDEX = 'SET_TAB_ITEM_TO_INDEX';
exports.SET_EDIT_INDEX = 'SET_EDIT_INDEX';
exports.SET_DRAG_NODE_ID = 'SET_DRAG_NODE_ID';
exports.INIT_TAB_BAR_INFO = 'INIT_TAB_BAR_INFO';
exports.INIT_TAB_BAR = 'INIT_TAB_BAR';
exports.SET_EXPANDED_KEYS = 'SET_EXPANDED_KEYS';
exports.TOGGLE_API_PANEL = 'TOGGLE_API_PANEL';
exports.TOGGLE_SIDE_RECORD_PANEL = 'TOGGLE_SIDE_RECORD_PANEL';
exports.TOGGLE_RECORD_PANEL_FULL_SCREEN = 'TOGGLE_RECORD_PANEL_FULL_SCREEN';
// user
exports.SET_USER_ME = 'SET_USER_ME';
exports.SET_IS_LOGIN = 'SET_IS_LOGIN';
exports.SET_HOME_ERR = 'SET_HOME_ERR';
exports.SET_REGISTER_STATUS = 'SET_REGISTER_STATUS';
exports.SET_USED_INVITE_REWARD = 'SET_USED_INVITE_REWARD';
exports.SET_IS_CODE = 'SET_IS_CODE';
exports.SET_IS_CREATE_SPACE = 'SET_IS_CREATE_SPACE';
exports.SET_LOADING = 'SET_LOADING';
exports.SIGN_OUT = 'SIGN_OUT';
exports.SET_USER_AVATAR = 'SET_USER_AVATAR';
exports.SET_USER_AVATAR_COLOR = 'SET_USER_AVATAR_COLOR';
exports.SET_USER_TIMEZONE = 'SET_USER_TIMEZONE';
exports.SET_REQ_STATUS = 'SET_REQ_STATUS';
exports.SET_HTTP_ERR_INFO = 'SET_HTTP_ERR_INFO';
exports.SET_ACTIVE_RECORD_ID = 'SET_ACTIVE_RECORD_ID';
exports.SET_PWD = 'SET_PWD';
/**
 * current row record that can be drag
 */
exports.SET_DRAG_TARGET = 'SET_DRAG_TARGET';
/**
 * set drag move target
 */
exports.SET_DRAG_MOVE = 'SET_DRAG_MOVE';
/**
 * set current mouse hover state
 */
exports.SET_HOVER_RECORD_ID = 'SET_HOVER_RECORD_ID';
exports.UPDATE_SOCIAL_CONFIG = 'UPDATE_SOCIAL_CONFIG';
// page params
exports.SET_PAGE_PARAMS = 'SET_PAGE_PARAMS';
exports.SET_ACTIVE_FIELD_STATE = 'SET_ACTIVE_FIELD_STATE';
exports.SET_TEMP_SELECTION = 'SET_TEMP_SELECTION';
// space
exports.SET_SPACE_LIST = 'SET_SPACE_LIST';
exports.SET_QUIT_SPACE_ID = 'SET_QUIT_SPACE_ID';
exports.SET_SPACE_ERR = 'SET_SPACE_ERR';
exports.SET_SPACE_LOADING = 'SET_SPACE_LOADING';
exports.SET_SPACE_INFO = 'SET_SPACE_INFO';
exports.SET_SPACE_FEATURES = 'SET_SPACE_FEATURES';
exports.SET_SHORTCUT_KEY_PANEL_VISIBLE = 'SET_SHORTCUT_KEY_PANEL_VISIBLE';
exports.SET_MARKETPLACE_APPS = 'SET_MARKETPLACE_APPS';
exports.SET_ACTIVE_SPACE_ID = 'SET_ACTIVE_SPACE_ID';
exports.SET_ENVS = 'SET_ENVS';
exports.SET_CHANGE_COLUMNS_WIDTH = 'SET_CHANGE_COLUMNS_WIDTH';
/**
 * the collapse of grouping
 */
exports.SET_GROUPING_COLLAPSE = 'SET_GROUPING_COLLAPSE';
/**
 * the collapse of kanban(board view)
 */
exports.SET_KANBAN_GROUPING_EXPAND = 'SET_KANBAN_GROUPING_EXPAND';
/**
 * control kanban view setting menu's collapse
 */
exports.TOGGLE_KANBAN_GROUP_SETTING_VISIBLE = 'TOGGLE_KANBAN_GROUP_SETTING_VISIBLE';
// Gantt View
/**
 * Gantt View left side panel hide/show
 */
exports.TOGGLE_GANTT_GRID = 'TOGGLE_GANTT_GRID';
/**
 * Gantt View left side task panel width
 */
exports.SET_GANTT_GRID_WIDTH = 'SET_GANTT_GRID_WIDTH';
/**
 * Gantt View right side setting panel hide/show
 */
exports.TOGGLE_GANTT_SETTING_PANEL = 'TOGGLE_GANTT_SETTING_PANEL';
/**
 * Gantt View right side setting panel width
 */
exports.SET_GANTT_SETTING_PANEL_WIDTH = 'SET_GANTT_SETTING_PANEL_WIDTH';
/**
 * Gantt View's time unit type
 */
exports.SET_GANTT_DATE_UNIT_TYPE = 'SET_GANTT_DATE_UNIT_TYPE';
// Calendar View
exports.TOGGLE_CALENDAR_GUIDE_STATUS = 'TOGGLE_CALENDAR_GUIDE_STATUS';
exports.TOGGLE_CALENDAR_GRID = 'TOGGLE_CALENDAR_GRID';
exports.SET_CALENDAR_GRID_WIDTH = 'SET_CALENDAR_GRID_WIDTH';
exports.TOGGLE_CALENDAR_SETTING_PANEL = 'TOGGLE_CALENDAR_SETTING_PANEL';
exports.SET_CALENDAR_SETTING_PANEL_WIDTH = 'SET_CALENDAR_SETTING_PANEL_WIDTH';
// OrgChart View
exports.TOGGLE_ORG_CHART_GUIDE_STATUS = 'TOGGLE_ORG_CHART_GUIDE_STATUS';
exports.TOGGLE_ORG_CHART_GRID = 'TOGGLE_ORG_CHART_GRID';
exports.SET_ORG_CHART_GRID_WIDTH = 'SET_ORG_CHART_GRID_WIDTH';
exports.TOGGLE_ORG_CHART_SETTING_PANEL = 'TOGGLE_ORG_CHART_SETTING_PANEL';
exports.SET_ORG_CHART_SETTING_PANEL_WIDTH = 'SET_ORG_CHART_SETTING_PANEL_WIDTH';
/**
 * the state of edit
 */
exports.SET_EDIT_STATUS = 'SET_EDIT_STATUS';
/**
 * write it down, the modified node description
 */
exports.RECORD_NODE_DESC = 'RECORD_NODE_DESC';
exports.SET_SHARE_MEMBER_ID = 'SET_SHARE_MEMBER_ID';
exports.RECORD_NODE_SHARED = 'RECORD_NODE_SHARED';
exports.SET_SCREEN_WIDTH = 'SET_SCREEN_WIDTH';
exports.SET_SIDEBAR_VISIBLE = 'SET_SIDEBAR_VISIBLE';
exports.SET_NODE_ICON = 'SET_NODE_ICON';
exports.CLEAR_FIELD_INFO = 'CLEAR_FIELD_INFO';
// hook
exports.UPDATE_PENDING_GUIDE_WIZARD_IDS = 'UPDATE_PENDING_GUIDE_WIZARD_IDS';
exports.UPDATE_CURRENT_GUIDE_STEP_IDS = 'UPDATE_CURRENT_GUIDE_STEP_IDS';
exports.UPDATE_CONFIG = 'UPDATE_CONFIG';
exports.UPDATE_TRIGGERED_GUIDE_INFO = 'UPDATE_TRIGGERED_GUIDE_INFO';
exports.INIT_HOOKS_DATA = 'INIT_HOOKS_DATA';
exports.UPDATE_CURRENT_GUIDE_WIZARD_ID = 'UPDATE_CURRENT_GUIDE_WIZARD_ID';
exports.CLEAR_WIZARDS_DATA = 'CLEAR_WIZARDS_DATA';
// toolbar
exports.SET_TOOLBAR_MENU_CARD_OPEN = 'SET_TOOLBAR_MENU_CARD_OPEN';
// rightPane
exports.SET_RIGHT_PANE_WIDTH = 'SET_RIGHT_PANE_WIDTH';
exports.UPDATE_UNIT_MAP = 'UPDATE_UNIT_MAP';
exports.UPDATE_USER_MAP = 'UPDATE_USER_MAP';
exports.SET_SEARCH_KEYWORD = 'SET_SEARCH_KEYWORD';
exports.RESET_UNIT_INFO = 'RESET_UNIT_INFO';
exports.SET_SEARCH_RESULT_CURSOR_INDEX = 'SET_SEARCH_RESULT_CURSOR_INDEX';
exports.SET_HOVER_GROUP_PATH = 'SET_HOVER_GROUP_PATH';
exports.SET_HOVER_ROW_OF_ADD_RECORD = 'SET_HOVER_ROW_OF_ADD_RECORD';
exports.TOGGLE_TIME_MACHINE_PANEL = 'TOGGLE_TIME_MACHINE_PANEL';
// Form
exports.FORM_JOT_ACTION = 'FORM_JOT_ACTION';
exports.FORM_REQUEST = 'FORM_REQUEST';
exports.FORM_LOADED = 'FORM_LOADED';
exports.FORM_CONNECTED = 'FORM_CONNECTED';
exports.FORM_PROP_UPDATE = 'FORM_PROP_UPDATE';
exports.UPDATE_FORM = 'UPDATE_FORM';
exports.FORM_ROOM_INFO_SYNC = 'FORM_ROOM_INFO_SYNC';
exports.SET_FORM_CLIENT = 'SET_FORM_CLIENT';
exports.SET_FORM_LOADING = 'SET_FORM_LOADING';
exports.SET_FORM_DATA = 'SET_FORM_DATA';
exports.SET_FORM_SYNCING = 'SET_FORM_SYNCING';
exports.UPDATE_FORM_NAME = 'UPDATE_FORM_NAME';
exports.FORM_DEACTIVATE_COLLABORATOR = 'FORM_DEACTIVATE_COLLABORATOR';
exports.FORM_ACTIVE_COLLABORATOR = 'FORM_ACTIVE_COLLABORATOR';
exports.RESET_FORM = 'RESET_FORM';
exports.SET_RECORD_VISION_MODE = 'SET_RECORD_VISION_MODE';
exports.SET_THEME = 'SET_THEME';
// resource
exports.RESOURCE_CONNECTED = 'RESOURCE_CONNECTED';
exports.CHANGE_RESOURCE_SYNCING_STATUS = 'CHANGE_RESOURCE_SYNCING_STATUS';
exports.UPDATE_FORM_UNIT_MAP = 'UPDATE_FORM_UNIT_MAP';
// globalState
exports.SET_RIGHT_CLICK_INFO = 'SET_RIGHT_CLICK_INFO';
// Widget Panel
exports.TOGGLE_WIDGET_PANEL = 'TOGGLE_WIDGET_PANEL';
exports.CHANGE_WIDGET_PANEL_WIDTH = 'CHANGE_WIDGET_PANEL_WIDTH';
exports.SWITCH_ACTIVE_PANEL = 'SWITCH_ACTIVE_PANEL';
exports.SET_WIDGET_PANEL_LOADING = 'SET_WIDGET_PANEL_LOADING';
// Widget
exports.RECEIVE_INSTALLATIONS_WIDGET = 'RECEIVE_INSTALLATIONS_WIDGET';
exports.RESET_WIDGET = 'RESET_WIDGET';
// Dashboard
exports.SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING';
exports.SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
exports.SET_DASHBOARD_CLIENT = 'SET_DASHBOARD_CLIENT';
exports.RESET_DASHBOARD = 'RESET_DASHBOARD';
exports.UPDATE_DASHBOARD_NAME = 'UPDATE_DASHBOARD_NAME';
exports.UPDATE_DASHBOARD_INFO = 'UPDATE_DASHBOARD_INFO';
// Mirror
exports.SET_MIRROR_LOADING = 'SET_MIRROR_LOADING';
exports.SET_MIRROR_DATA = 'SET_MIRROR_DATA';
exports.SET_MIRROR_CLIENT = 'SET_MIRROR_CLIENT';
exports.RESET_MIRROR = 'RESET_MIRROR';
exports.UPDATE_MIRROR_NAME = 'UPDATE_MIRROR_NAME';
exports.UPDATE_MIRROR_INFO = 'UPDATE_MIRROR_INFO';
exports.MIRROR_JOT_ACTION = 'MIRROR_JOT_ACTION';
// RESOURCE JOT_ACTION
exports.DATASHEET_JOT_ACTION = 'DATASHEET_JOT_ACTION';
exports.DASHBOARD_JOT_ACTION = 'DASHBOARD_JOT_ACTION';
exports.WIDGET_JOT_ACTION = 'WIDGET_JOT_ACTION';
// RESOURCE UPDATE_REVISION
exports.MIRROR_UPDATE_REVISION = 'MIRROR_UPDATE_REVISION';
exports.DATASHEET_UPDATE_REVISION = 'DATASHEET_UPDATE_REVISION';
exports.DASHBOARD_UPDATE_REVISION = 'DASHBOARD_UPDATE_REVISION';
exports.WIDGET_UPDATE_REVISION = 'WIDGET_UPDATE_REVISION';
exports.FORM_UPDATE_REVISION = 'FORM_UPDATE_REVISION';
// RESOURCE CONNECTING
exports.DATASHEET_CONNECTED = 'DATASHEET_CONNECTED';
exports.DASHBOARD_CONNECTED = 'DASHBOARD_CONNECTED';
exports.MIRROR_CONNECTED = 'MIRROR_CONNECTED';
// RESOURCE SYNC
exports.SET_DATASHEET_SYNCING = 'SET_DATASHEET_SYNCING';
exports.SET_DASHBOARD_SYNCING = 'SET_DASHBOARD_SYNCING';
exports.SET_MIRROR_SYNCING = 'SET_MIRROR_SYNCING';
// RESOURCE ROOM_INFO
exports.DATASHEET_ROOM_INFO_SYNC = 'DATASHEET_ROOM_INFO_SYNC';
exports.DASHBOARD_ROOM_INFO_SYNC = 'DASHBOARD_ROOM_INFO_SYNC';
exports.MIRROR_ROOM_INFO_SYNC = 'MIRROR_ROOM_INFO_SYNC';
// RESOURCE ERR CODE
exports.FORM_ERROR_CODE = 'FORM_ERROR_CODE';
exports.DATASHEET_ERROR_CODE = 'DATASHEET_ERROR_CODE';
exports.DASHBOARD_ERROR_CODE = 'DASHBOARD_ERROR_CODE';
exports.MIRROR_ERROR_CODE = 'MIRROR_ERROR_CODE';
// RESOURCE UPDATE
exports.UPDATE_DATASHEET = 'UPDATE_DATASHEET';
exports.UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
exports.UPDATE_MIRROR = 'UPDATE_MIRROR';
exports.UPDATE_SNAPSHOT = 'UPDATE_SNAPSHOT';
exports.MIRROR_SAVE_STATUS = 'MIRROR_SAVE_STATUS';
// EXPAND RECORD
exports.EXPAND_STATUS = 'EXPAND_STATUS';
// template
exports.UPDATE_TEMPLATE_CATEGORY = 'UPDATE_TEMPLATE_CATEGORY';
exports.UPDATE_TEMPLATE_DIRECTORY = 'UPDATE_TEMPLATE_DIRECTORY';
// share
exports.SET_SHARE_INFO = 'SET_SHARE_INFO';
// preview
exports.SET_PREVIEW_MODAL_VISIBLE = 'SET_PREVIEW_MODAL_VISIBLE';
// fieldPermissionMap
exports.UPDATE_FIELD_PERMISSION_MAP = 'UPDATE_FIELD_PERMISSION_MAP';
exports.RESET_FIELD_PERMISSION_MAP = 'RESET_FIELD_PERMISSION_MAP';
exports.LOAD_FIELD_PERMISSION_MAP = 'LOAD_FIELD_PERMISSION_MAP';
exports.UPDATE_FIELD_PERMISSION_SETTING = 'UPDATE_FIELD_PERMISSION_SETTING';
// browser worker computed datasheet cached data.
exports.UPDATE_DATASHEET_COMPUTED = 'UPDATE_DATASHEET_COMPUTED';
exports.SET_DATASHEET_COMPUTED = 'SET_DATASHEET_COMPUTED';
exports.UPDATE_DATASHEET_COMPUTED_ROWS = 'UPDATE_DATASHEET_COMPUTED_ROWS';
exports.UPDATE_DATASHEET_COMPUTED_COLUMNS = 'UPDATE_DATASHEET_COMPUTED_COLUMNS';
exports.SET_DATASHEET_COMPUTED_STATUS = 'SET_DATASHEET_COMPUTED_STATUS';
exports.SET_CLOSE_SYNC_VIEW_ID = 'SET_CLOSE_SYNC_VIEW_ID';
/**
 * Labs Features
 */
exports.SET_LABS = 'SET_LABS';
/**
 * Data subscribe(follow) features
 */
exports.SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
/**
 * Preview file
 */
exports.SET_PREVIEW_FILE = 'SET_PREVIEW_FILE';
exports.SET_PREVIEW_FILE_CELL_ACTIVE = 'SET_PREVIEW_FILE_CELL_ACTIVE';
exports.SET_PREVIEW_DEFAULT_ACTIVE = 'SET_PREVIEW_DEFAULT_ACTIVE';
/**
 * View derivation
 */
exports.SET_VIEW_DERIVATION = 'SET_VIEW_DERIVATION'; // Update view derivation
exports.DELETE_VIEW_DERIVATION = 'DELETE_VIEW_DERIVATION'; // Delete
exports.PATCH_VIEW_DERIVATION = 'PATCH_VIEW_DERIVATION'; // Update part of the view derivation.
exports.TRIGGER_VIEW_DERIVATION_COMPUTED = 'TRIGGER_VIEW_DERIVATION_COMPUTED'; // Calculating view-derived data triggers action
//# sourceMappingURL=action_constants.js.map